import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { Icon } from "../Common";
import { generateID } from "../../helpers/uiHelpers";

export class Search extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    onSubmit: PropTypes.func,
    value: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleChange = _.debounce(this.handleChange, 1000);
  }

  state = {
    hasInputValue: false
  };

  componentDidMount() {
    if (this.props.value) {
      this.searchInputRef.current.value = this.props.value;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.searchInputRef.current.value = this.props.value;
    }
  }

  get className() {
    return classNames("search__search-box", this.props.className, { "-filled": this.state.hasInputValue });
  }

  handleBlur = event => this.setState({ hasInputValue: !_.isEmpty(event.target.value) });

  handleChange = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.searchInputRef.current.value.replace(/;/g, ""));
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    this.handleChange();
  };

  searchInputRef = React.createRef();

  id = generateID("search");

  render() {
    return (
      <div className="search">
        <form role="search" className={this.className} onSubmit={this.handleSubmit}>
          <label className="search__label" htmlFor={this.id}>
            <i className="search__icon">
              <Icon id="search" />
            </i>
          </label>

          <input
            type="text"
            id={this.id}
            className="search__field"
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            ref={this.searchInputRef}
            maxLength="100"
            placeholder={`${i18n.t("searchBar.search")} ...`}
          />

          <button className="search__submit" />
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Search.js